module.exports = __webpack_public_path__ + "img/cooling.743b8dbc.jpeg";